import { prettifyDate, prettifyHours } from 'odfjell-date-time-utils/dateTimeFormatter';
import { InputProps } from '../OdfjellInputComponent';
import { ReadOnlyInput } from '../OdfjellInputComponent.style';

const ReadonlyComponent: React.FC<Partial<InputProps>> = ({ type, value, options }: Partial<InputProps>) => {
    if (type === 'date') {
        return <div>{prettifyDate(value)}</div>;
    }
    if (type === 'time' || type === 'duration') {
        return <span>{prettifyHours(value)}</span>;
    }
    if (type === 'checkbox') {
        return <input type="checkbox" checked={value || false} disabled />;
    }
    if (type === 'select') {
        // If options provided in { value, label } shape, map value to label; fall back to raw value
        if (Array.isArray(options)) {
            const opt = options.find((o: any) => (o?.value ?? o) === value);
            const label = opt?.label ?? (typeof opt === 'string' ? opt : undefined);
            return <ReadOnlyInput className="read-only-input">{label ?? value}</ReadOnlyInput>;
        }
    }
    return <ReadOnlyInput className="read-only-input">{value}</ReadOnlyInput>;
};

export default ReadonlyComponent;
